import React from "react"
import Arrow from "../svg/arrow"
import styled from "styled-components"

const FigArrow = styled.figure`
  will-change: transform;
`
const ButtonArrow = ({ title, click, active, onClick }) => {
  return (
    <button
      className="flex items-center space-x-4.5 leading-none group"
      onClick={onClick}
    >
      <span>{title}</span>

      <FigArrow
        className={`-mb-px  w-7.5px h-auto transition duration-500 transform ${
          click ? " duration-300" : " duration-1000 group-hover:rotate-360"
        }

        
      ${click && active ? "rotate-180" : ""}`}
      >
        <Arrow></Arrow>
      </FigArrow>
    </button>
  )
}

export default ButtonArrow
